import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const AuthCallback = () => {
  const { loginWithToken } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token) {
      toast.error("Falha na autenticação com Google");
      nav("/login", { replace: true });
      return;
    }

    loginWithToken(token)
      .then((user) => {
        toast.success(`Bem-vindo, ${user.name}!`);
        nav(user.role === "rh" ? "/rh" : "/colaborador", { replace: true });
      })
      .catch(() => {
        toast.error("Erro ao autenticar. Tente novamente.");
        nav("/login", { replace: true });
      });
  }, []);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-background">
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
      <p className="text-sm text-muted-foreground">Autenticando com Google...</p>
    </div>
  );
};

export default AuthCallback;
